import { request } from '@umijs/max';
import { RequestType } from '@/interface';
import { HouseType, SetDefaultParamsType } from '@/pages/House/interface';

/**
 * @desc 解除绑定房屋
 * @param id
 */
export const queryUnBindHouse = async (id?: string) => {
  return request(`/api/property/api/senke/Wxchat/relieveBinding/room/${id}`, {
    method: 'POST',
  });
};

/**
 * @desc 查询绑定小区
 * @param params
 */
export const queryBindHouse = async (params: {
  communityId?: string;
  openId?: string;
}) => {
  return request<Promise<RequestType<Array<HouseType>>>>(
    '/api/property/api/senke/Wxchat/binding/getCommunitys',
    {
      method: 'GET',
      params,
    },
  );
};

/**
 * @desc 设置默认房屋
 * @param data
 */
export const querySetDefaultHouse = async (data: SetDefaultParamsType) => {
  return request('/api/property/api/senke/Wxchat/defaultRoomSet', {
    method: 'POST',
    data,
  });
};
